// extracted by mini-css-extract-plugin
export default {"styled":"NavigationFooter_styled__R4iH7","back":"NavigationFooter_back__Lp-oW"};